export const formatMoney = (cents: number): string => (
    new Intl.NumberFormat(
        'en-US',
        {style: 'currency', currency: 'EUR'}
    ).format(cents / 100)
);